import { render, staticRenderFns } from "./ClaimsPopup.vue?vue&type=template&id=12f617ba&scoped=true"
import script from "./ClaimsPopup.vue?vue&type=script&lang=ts"
export * from "./ClaimsPopup.vue?vue&type=script&lang=ts"
import style0 from "./ClaimsPopup.vue?vue&type=style&index=0&id=12f617ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f617ba",
  null
  
)

export default component.exports